(function () {
  'use strict';
  if (window.LPBottomTrustFit) { window.LPBottomTrustFit.init(); return; }
  const instances = new Map();
  const context = document.createElement('canvas').getContext('2d');
  if (!context) return;

  function init() {
    document.querySelectorAll('.lp-bottom-trust-wrapper--reference[data-bottom-trust-fit]').forEach(root => {
      if (instances.has(root)) return;
      const grid = root.querySelector('.lp-bottom-trust-features');
      if (!grid) return;
      let frame = null, lastWidth = -1;
      function setProperty(key, value) {
        if (root.style.getPropertyValue(key) !== value) root.style.setProperty(key, value);
      }
      function setFlag(key, enabled) {
        if (root.hasAttribute(key) !== enabled) root.toggleAttribute(key, enabled);
      }
      function fit(selector, baseSize, minimum, property, flag) {
        const nodes = [...root.querySelectorAll(selector)];
        let ratio = 1;
        for (const node of nodes) {
          const text = node.textContent.trim().replace(/\s+/g, ' ');
          if (!text) continue;
          const style = getComputedStyle(node);
          context.font = `${style.fontStyle} ${style.fontWeight} ${baseSize}px ${style.fontFamily}`;
          const measured = context.measureText(text).width;
          const available = node.parentElement.clientWidth - 2;
          if (available <= 0 || !Number.isFinite(measured)) return;
          if (measured > 0) ratio = Math.min(ratio, available / measured);
        }
        const requested = Math.floor(baseSize * ratio * 10) / 10;
        const floor = Math.min(baseSize, minimum);
        const size = Math.max(floor, requested);
        setProperty(property, size + 'px');
        // Never truncate copy or force unreadably small text on narrow windows.
        setFlag(flag, requested >= floor);
      }
      function update() {
        frame = null;
        if (!root.isConnected) return;
        if (!matchMedia('(min-width: 750px)').matches) {
          root.style.removeProperty('--lp-bottom-trust-fitted-title-size');
          root.style.removeProperty('--lp-bottom-trust-fitted-body-size');
          setFlag('data-lp-bottom-trust-title-single-line', false);
          setFlag('data-lp-bottom-trust-body-single-line', false);
          return;
        }
        const style = getComputedStyle(root);
        const titleSize = parseFloat(style.getPropertyValue('--lp-bottom-trust-title-base-size'));
        const bodySize = parseFloat(style.getPropertyValue('--lp-bottom-trust-body-base-size'));
        if (titleSize > 0) fit('.lp-bottom-trust-title', titleSize, 12, '--lp-bottom-trust-fitted-title-size', 'data-lp-bottom-trust-title-single-line');
        if (bodySize > 0) fit('.lp-bottom-trust-desc', bodySize, 10, '--lp-bottom-trust-fitted-body-size', 'data-lp-bottom-trust-body-single-line');
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== lastWidth) { lastWidth = width; schedule(); }
      }) : null;
      if (observer) observer.observe(grid);
      else window.addEventListener('resize', schedule);
      instances.set(root, { schedule, dispose() {
        observer?.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', schedule);
        instances.delete(root);
      } });
      schedule();
    });
  }
  function refresh() { instances.forEach(instance => instance.schedule()); }
  window.LPBottomTrustFit = { init };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => { if (event.target.contains(root)) instance.dispose(); });
  });
  document.fonts?.ready.then(refresh);
  document.fonts?.addEventListener('loadingdone', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
